// extracted by mini-css-extract-plugin
export default {"content":"timer_content__0SWnS","content--pulled-up":"timer_content--pulled-up__9We+e","timer":"timer_timer__IGiXT","red-circle":"timer_red-circle__CfqEw"};